export const FETCH_S3_JSON_FAILED = 'fetch S3json';
export const GET_PRODUCTS_FAILED = 'get products';
export const AGREE_MEMBERSHIP_FAILED = 'agree membership';
export const GET_CLIENT_APPOINTMENTS_FAILED = 'get client appointments';
export const GET_MISSING_INTAKE_FAILED = 'get missing intake';
export const GET_MISSING_TREATMENTS_FAILED = 'get missing treatments';
export const DELETE_TREATMENT_RECORD_FAILED = 'delete treatment record';
export const CREATE_TREATMENT_NOTES_FAILED = 'create treatment notes';
export const SAVE_SKIN_PROFILE_FAILED = 'save skin profile';
export const UPDATE_TREATMENT_RECORD_FAILED = 'update treatment record';
export const GET_ALL_CLIENTS_FAILED = 'get all clients';
export const GET_ALL_APPOINTMENTS_FAILED = 'get all appointments';
export const GET_TIME_SHIFTS_FAILED = 'get shift times';
export const GET_ALL_TIME_BLOCKS_FAILED = 'get all time blocks';
export const GET_ALL_LOCATIONS_STAFFID_FAILED = 'get all locations by staffId';
export const GET_CLIENT_DETAILS_FAILED = 'get client details';
export const GET_TREATMENTS_FAILED = 'get treatments';
export const GET_PAST_PURCHASES_FAILED = 'get past purchases';
export const GET_PRODUCT_VARIANT_FAILED = 'get products by variantIds';
export const GET_KNACK_RECORDS_FAILED = 'get knack records';
export const GET_PRODUCTS_AVOID_FAILED = 'get products to avoid';
export const CREATE_TREATMENT_RECORD_FAILED = 'fetch create treatment record';
export const GET_TREATMENT_DETAILS_FAILED = 'get treatment details';
export const UPDATE_TREATMENT_NOTES_FAILED = 'update treatment notes';
export const GET_ALL_STAFF_BY_LOCATIONID_FAILED =
  'get all staff by location Id';
export const INTAKE_SAVE_FAILED = 'save intake section';
export const DRAFT_TR_SAVE_FAILED = 'draft treatment record';
export const BLVD_TIMEBLOCK_API_ERROR = 'BLVD Timeblock API error';
export const DEFAULT_ERROR_MESSAGE =
  'Unfortunately an error occured while trying to complete your request. Please try again in a few minutes.';
